import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePageGoogle from '../Components/HomePageGoogle/HomePageGoogle'
import NotFound from '../Tools/NotFound/NotFound'

export default function Main({ CitiePhone, CitiesData, navigateTo, Blogs, FaqList, WebSitePages }) {

    return (
        // <div>
        <Routes>
            <Route path="/" element={<HomePageGoogle CitiePhone={CitiePhone}  CitiesData={CitiesData} navigateTo={navigateTo} Blogs={Blogs} FaqList={FaqList} />} />
            {/* <Route path="/" element={<HomePage CitiePhone={CitiePhone} navigateTo={navigateTo} Blogs={Blogs} FaqList={FaqList} />} /> */}
            <Route path="/local" element={<HomePageGoogle CitiePhone={CitiePhone}  CitiesData={CitiesData} navigateTo={navigateTo} Blogs={Blogs} FaqList={FaqList} />} />
            {/* Services */}
            <Route path="*" element={<NotFound CitiePhone={CitiePhone} />} />
        </Routes>
        // </div>
    )
}
